/* eslint-disable no-console */
/* eslint-disable default-param-last */
import { ActionTypes } from '../constants/Actions-Types';

let initialID = 0;
let initialBadgeType = 'guide';
let MainTabID = 4;
let devTabID = 0;
let levelID = 0;
let roleID = 0;
let journeyTab = 0;
let capstoneActivityID = 1;
let levelKey = 0;
let guideID = 0;
let deptID = 0;
let deptEmpCnt = 0;
let progress = true;
let journeyID = 0;
let selectedPubDate = '';
let capstoneID = 1;
const initialState = {
  devAccess: false,
  isDevPanelOpen: false,
  dealershipID: 0,
  dealershiplist: [],
  tempCheckDept: [],
  tempCheckRoles: [],
  checkedAssignedJourneys: [],
  checkedAssignedInstr: [],
  mandatoryJourneys: [],
  dealershipAssignedJourneys: {},
  checkedJourneys: [],
  checkedInstructors: [],
  doseDetails: {
    doseDetails: {
      id: '',
      title: '',
      description: '',
      thumbnail: '',
      articleLink: '',
      publishDate: '',
      readingTime: 0,
      punchline: '',
      avLink: null,
      type: '',
    },
  },
  doses: {
    doses: {
      id: '',
      title: '',
      description: '',
      thumbnail: '',
      articleLink: '',
      publishDate: '',
      readingTime: 0,
      punchline: '',
      avLink: null,
      type: '',
    },
  },
  dealershipdetails: {
    dealershipdetails: {
      id: 1,
      name: '',
      address: '',
      pinCode: '',
      city: '',
      country: '',
      domainName: '',
      domainList: [],
      primaryContactName: '',
      primaryContactNumber: '',
      primaryContactEmail: '',
      enabled: true,
      source: '',
    },
  },
  assignedJourneys: {},
  planassignedJourneys: {},
  journeylist: [],
  departments: [],
  planlist: [],
  collectionlist: [],
  employeelist: [],
  badgeTypeList: [],
  authClientList: [],
  allbadges: {
    allbadges: [],
  },
  journeydetails: {
    journeydetails: {
      id: 1,
      employeeJourneyId: '',
      title: '',
      journeyTags: [],
      levels: [],
      currentLevelId: '',
      currentGuideId: '',
      completionStatus: '',
      totalGuides: '',
      completedGuides: '',
      thumbnail: '',
      publishDate: '',
    },
  },
  leveldetails: {
    leveldetails: {
      title: ' ',
      description: '',
      guides: [],
      capstoneActivitiesCount: 0,
      duration: 0,
    },
  },
  plandetails: [],
  collectiondetails: [],
  capstonedetails: {
    capstonedetails: {
      id: '',
      title: ' ',
      description: '',
    },
  },
  capstoneactivitydetails: {
    capstoneactivitydetails: {
      id: 1,
      levelId: 1,
      capstoneActivityTypeId: 1,
      title: '',
      subTitle: '',
      description: '',
      instructions: {
        title: '',
        points: [],
        subTitle: '',
        detail: '',
      },
      externalUrl: '',
    },
  },
  authclientdetails: {
    authclientdetails: {},
  },
  guidedetails: {
    guidedetails: {
      id: '',
      title: '',
      goal: '',
      description: '',
      duration: 10,
      contentUrl: '',
      thumbnail: '',
      videoLink: null,
      guideTags: [],
    },
  },

  capstoneactivitylist: {
    capstoneactivitylist: {
      id: '',
      title: '',
      type: '',
    },
  },
  taglist: [],
  planAuth: [],
  collectionfilters: [],
  collection: [],
  dealershipMenu: [],
  dealershipDepartmentValues: [],
  catlist: [],
  instrList: [],
  departmentRole: [],
  guideInstrList: [],
  guidetaglist: [],
  rolelist: [],
  deptrolelist: [],
  selectedtagsjourney: [],
  selecteddealershipsfilter: {
    selecteddealershipsfilter: ['Enabled', 'Disabled', 'ADMIN', 'BMW'],
  },
  pubDates: [],
  selDeptRoles: {
    selDeptRoles: [],
  },
  dealershipChildren: [],
  dealershipCustomGroups: [],
  dealershipRules: [],
  category: {
    categoryList: [],
    selectedId: null,
    selectedCategoryDept: [],
    selectedCategoryDeptCollections: [],
  },
  dealershipTags: [],
  leaderboard: {
    selectedLeaderboard: null,
    leaderboardOverview: {},
    leaderboardList: [],
  },
  contest: {
    contestList: [],
    selectedId: null,
    selectedContestDetails: {},
    selectedContestDealershipList: [],
  },
  adminUsers: {
    list: [],
    selectedId: null,
    selectedAdminDetails: {},
  },
  networkPartner: {
    networkPartnerList: [],
  },
  rnp: {
    rnpList: [],
  },
  inapp: {
    inappList: [],
    selectedId: null,
    selectedInappDetails: {},
    selectedInappDealershipList: [],
  },
  customGroup: {
    customGroupsList: [],
    selectedId: 0,
    selectedCustomGroupDetails: {},
  },
  rules: {
    rulesList: [],
    selectedId: 0,
    selectedRuleDetails: {},
  },
  topicOfTheMonth: {
    datesList: [],
    selectedDate: '',
    selectedDateData: [],
    selectedTopicId: 0,
    selectedTopicData: {},
  },
  customDepartment: {},
  pxDashboard: {
    userList: [],
    selectedUser: {},
    selectedUserTabDetails: {},
    filters: {},
  },
  rockedCurriculum: {
    rolesList: [],
    selectedRole: {},
    selectedTenure: {},
    selectedRoleTabDetails: {},
    filters: {},
    tenures: [],
  },
  rockedFuel: {
    categoriesList: [],
    selectedCategory: {},
    selectedSubCategory: {},
    selectedFuel: {},
    fuels: [],
  },
  topics: {
    topicsList: [],
    selectedTopic: {},
    selectedTopicInfo: {},
  },
  certificates: {
    certList: [],
    selectedCert: {},
    selectedCertInfo: {},
    selectedCertInfoEdit: {},
  },
  aiRoleplay: {
    exerciseCategories: [],
    exercise: {},
    selectedCategory: {},
    selectedExercise: {},
  },
  quizSeriesList: [],
  quizSeries: {
    selectedId: null,
    quizSeriesOverview: {},
  },
  quiz: {
    selectdId: null,
    quizDetails: [],
  },
};

export const insertReducer = (state = [], action) => {
  switch (action.type) {
    case ActionTypes.INSERT_DEALERSHIP:
      return { ...state, dealership: action.payload };
    default: {
      return state;
    }
  }
};
export const getSelectedBadgeType = (state = initialBadgeType, { type, payload }) => {
  switch (type) {
    case 'BADGETYPE':
      initialBadgeType = payload;
      return initialBadgeType;
    default:
      return state;
  }
};
export const getSelectedAuthClientID = (state = initialBadgeType, { type, payload }) => {
  switch (type) {
    case 'AUTHCLIENTID':
      initialBadgeType = payload;
      return initialBadgeType;
    default:
      return state;
  }
};
export const getDealershipID = (state = initialID, { type, payload }) => {
  switch (type) {
    case 'ID':
      initialID = payload;
      return initialID;
    default:
      return state;
  }
};
export const getGuideID = (state = guideID, { type, payload }) => {
  switch (type) {
    case 'GUIDEID':
      guideID = payload;
      return guideID;
    default:
      return state;
  }
};
export const getJourneyID = (state = journeyID, { type, payload }) => {
  switch (type) {
    case 'JID':
      journeyID = payload;
      return journeyID;
    default:
      return state;
  }
};
export const getCapstoneID = (state = capstoneID, { type, payload }) => {
  switch (type) {
    case 'CID':
      capstoneID = payload;
      return capstoneID;
    default:
      return state;
  }
};
export const getMainTabID = (state = MainTabID, { type, payload }) => {
  switch (type) {
    case 'mainTabID':
      MainTabID = payload;
      return MainTabID;
    default:
      return state;
  }
};
export const getSelectedPubDate = (state = selectedPubDate, { type, payload }) => {
  switch (type) {
    case 'SELECTEDPUBDATE':
      selectedPubDate = payload;
      return selectedPubDate;
    default:
      return state;
  }
};

export const getCapstoneActivityID = (state = capstoneActivityID, { type, payload }) => {
  switch (type) {
    case 'CAID':
      capstoneActivityID = payload;
      return capstoneActivityID;
    default:
      return state;
  }
};
export const getSelectedLevelID = (state = levelID, { type, payload }) => {
  switch (type) {
    case 'levelID':
      levelID = payload;
      return levelID;
    default:
      return state;
  }
};
export const getJourneyTab = (state = journeyTab, { type, payload }) => {
  switch (type) {
    case 'journeyTab':
      journeyTab = payload;
      return journeyTab;
    default:
      return state;
  }
};
export const getSelectedRoleID = (state = roleID, { type, payload }) => {
  switch (type) {
    case 'roleID':
      roleID = payload;
      return roleID;
    default:
      return state;
  }
};
export const getSelectedLevelKey = (state = levelKey, { type, payload }) => {
  switch (type) {
    case 'KEY':
      levelKey = payload;
      return levelKey;
    default:
      return state;
  }
};

export const getTagList = (state = initialState.taglist, { type, payload }) => {
  switch (type) {
    case 'TAGLIST':
      return { ...state, taglist: payload };
    default: {
      return state;
    }
  }
};
export const getTempChecksDept = (state = initialState.tempCheckDept, { type, payload }) => {
  switch (type) {
    case 'TEMP_DEPT':
      return { ...state, tempCheckDept: payload };
    case 'TEMP_DEPT_DES':
      return { ...state, tempCheckDept: [] };
    default: {
      return state;
    }
  }
};
export const getTempChecksRoles = (state = initialState.tempCheckRoles, { type, payload }) => {
  switch (type) {
    case 'TEMP_ROLES':
      return { ...state, tempCheckRoles: payload };
    case 'TEMP_ROLES_DES':
      return { ...state, tempCheckRoles: [] };
    default: {
      return state;
    }
  }
};
const instructorListInitialState = { instrList: [] };

const getInstrListFromState = (state) => {
  if (Array.isArray(state)) return state;
  if (Array.isArray(state?.instrList)) return state.instrList;
  return [];
};

export const getInstructorList = (state = instructorListInitialState, { type, payload }) => {
  const list = getInstrListFromState(state);

  switch (type) {
    case 'INSTRLIST':
      // eslint-disable-next-line no-nested-ternary
      return { instrList: Array.isArray(payload) ? payload : payload ? [payload] : [] };
    case 'INSTRLISTAPP':
      return { instrList: [...list, payload] };
    case 'INSTRLISTUP':
      return {
        instrList: list.map((instr) =>
          instr.id === payload.id
            ? {
                id: payload.id,
                name: payload.name,
                thumbnail: payload.thumbnail,
              }
            : instr,
        ),
      };
    default: {
      if (Array.isArray(state)) {
        return { instrList: state };
      }
      return state ?? instructorListInitialState;
    }
  }
};
export const getGuideInstructorList = (state = initialState.guideInstrList, { type, payload }) => {
  switch (type) {
    case 'GUIDEINSTRLIST':
      return { ...state, guideInstrList: payload };
    case 'GUIDEINSTRLISTAPP':
      return { ...state, guideInstrList: [...state.guideInstrList, payload] };
    case 'GUIDEINSTRLISTUP':
      return {
        ...state,
        guideInstrList: state.guideInstrList.map((instr) =>
          instr.id === payload.id
            ? {
                id: payload.id,
                name: payload.name,
                thumbnail: payload.thumbnail,
              }
            : instr,
        ),
      };
    default: {
      return state;
    }
  }
};
export const getPubDates = (state = initialState.pubDates, { type, payload }) => {
  switch (type) {
    case 'PUBDATES':
      return { ...state, pubDates: payload };
    case 'PUBDATESCON':
      if (payload[2] === 1) {
        return {
          ...state,
          pubDates: state.pubDates
            .filter((element) => element.publishDate !== payload[0])
            .concat({ publishDate: payload[1], type: [] }),
        };
      }
      return {
        ...state,
        pubDates: state.pubDates.concat({ publishDate: payload[1], type: [] }),
      };

    case 'PUBDATESAPP':
      return {
        ...state,
        pubDates: state.pubDates.filter((element) => element.publishDate !== payload[0]),
      };
    case 'PUBDATESREM':
      return {
        ...state,
        pubDates: state.pubDates.filter((element) => element.publishDate !== payload),
      };
    default: {
      return state;
    }
  }
};

export const getRoleList = (state = initialState.rolelist, { type, payload }) => {
  switch (type) {
    case 'ROLELIST':
      return { ...state, rolelist: payload };
    case 'INC_ROLE_COUNT':
      return {
        ...state,
        rolelist: state.rolelist.map((item) => {
          if (item.id === payload) {
            return {
              ...item,
              employeeCount: item.employeeCount + 1,
            };
          }
          return item;
        }),
      };
    case 'DEC_ROLE_COUNT':
      return {
        ...state,
        rolelist: state.rolelist.map((item) => {
          if (item.id === payload) {
            return {
              ...item,
              employeeCount: item.employeeCount - 1,
            };
          }
          return item;
        }),
      };
    default: {
      return state;
    }
  }
};
export const getDepartmentRoleList = (state = initialState.deptrolelist, { type, payload }) => {
  switch (type) {
    case 'DEPTROLELIST':
      return { ...state, deptrolelist: payload };
    default: {
      return state;
    }
  }
};

export const getSelectedDealershipFilters = (state = initialState.selecteddealershipsfilter, { type, payload }) => {
  switch (type) {
    case 'SELECTEDDEALFILTERS':
      return { ...state, selecteddealershipsfilter: payload };
    default: {
      return state;
    }
  }
};
export const getGuideTagList = (state = initialState.guidetaglist, { type, payload }) => {
  switch (type) {
    case 'GUIDETAGLIST':
      return { ...state, guidetaglist: payload };
    default: {
      return state;
    }
  }
};
export const getCheckedAssignedJourneys = (state = initialState.checkedAssignedJourneys, { type, payload }) => {
  switch (type) {
    case 'CHECKEDASSIGNEDJOURNEYS':
      return { ...state, checkedAssignedJourneys: payload };
    default: {
      return state;
    }
  }
};
export const getCheckedAssignedInstr = (state = initialState.checkedAssignedInstr, { type, payload }) => {
  switch (type) {
    case 'CHECKEDASSIGNEDINSTR':
      return { ...state, checkedAssignedInstr: payload };
    default: {
      return state;
    }
  }
};

export const getMandatoryJourneys = (state = initialState.mandatoryJourneys, { type, payload }) => {
  switch (type) {
    case 'MANDATORYJOURNEYS':
      return { ...state, mandatoryJourneys: payload };
    case 'APP_MANDATORYJOURNEYS':
      return {
        ...state,
        mandatoryJourneys: [...state.mandatoryJourneys, payload],
      };
    case 'REMMANDATORYJOURNEYS':
      return {
        ...state,
        mandatoryJourneys: [...state.mandatoryJourneys.filter((a) => a !== payload)],
      };
    default: {
      return state;
    }
  }
};

export const getDealershipAssignedJourneys = (
  state = { dealershipAssignedJourneys: initialState.dealershipAssignedJourneys },
  { type, payload },
) => {
  switch (type) {
    case 'DEALER_ASSIGNED_JOURNEYS':
      return { ...state, dealershipAssignedJourneys: payload };
    case 'ADD_DEALER_ASSIGNED_JOURNEYS': {
      const currentData = state.dealershipAssignedJourneys[payload.id] || {};
      return {
        ...state,
        dealershipAssignedJourneys: {
          ...state.dealershipAssignedJourneys,
          [payload.id]: { ...currentData, dealershipAssigned: payload.checked },
        },
      };
    }
    case 'DATE_DEALER_ASSIGNED_JOURNEYS': {
      const currentData = state.dealershipAssignedJourneys[payload.id] || {};
      return {
        ...state,
        dealershipAssignedJourneys: {
          ...state.dealershipAssignedJourneys,
          [payload.id]: { ...currentData, ...payload.dates },
        },
      };
    }
    default: {
      return state;
    }
  }
};

export const getCheckedJourneys = (state = initialState.checkedJourneys, { type, payload }) => {
  switch (type) {
    case 'CHECKEDJOURNEYS':
      return { ...state, checkedJourneys: payload };
    default: {
      return state;
    }
  }
};
export const getCheckedInstr = (state = initialState.checkedInstructors, { type, payload }) => {
  switch (type) {
    case 'CHECKEDINSTR':
      return { ...state, checkedInstructors: payload };
    default: {
      return state;
    }
  }
};
export const getDealershipList = (state = initialState.dealershiplist, { type, payload }) => {
  switch (type) {
    case ActionTypes.GET_DEALERSHIPLIST:
      return { ...state, dealershiplist: payload };
    case 'ADDEMPCOUNT':
      return {
        ...state,
        dealershiplist: [
          ...state.dealershiplist.map((val) => {
            if (val.id === payload.id) {
              return {
                id: val.id,
                name: val.name,
                hubspotId: val.hubspotId,
                enabled: val.enabled,
                timezone: val.timezone,
                leadPipeline: val.leadPipeline,
                employeesCount: payload.count,
                plans: val.plans,
              };
            }
            return val;
          }),
        ],
      };
    default: {
      return state;
    }
  }
};

export const getDealershipDetails = (state = initialState.dealershipdetails, { type, payload }) => {
  switch (type) {
    case ActionTypes.DEALERSHIPDETAILS:
      return { ...state, dealershipdetails: payload };
    default: {
      return state;
    }
  }
};

export const getChildrenDealerships = (state = initialState.dealershipChildren, { type, payload }) => {
  switch (type) {
    case ActionTypes.CHILDRENDEALERSHIPDETAILS:
      return { ...state, dealershipChildren: payload };
    default: {
      return state;
    }
  }
};

export const getCustomGroupsForDealership = (state = initialState.dealershipCustomGroups, { type, payload }) => {
  switch (type) {
    case 'GET_CUSTOM_GROUPS_FOR_DEALERSHIP':
      return { ...state, dealershipCustomGroups: payload };
    default: {
      return state;
    }
  }
};

export const getRulesForDealership = (state = initialState.dealershipRules, { type, payload }) => {
  switch (type) {
    case 'GET_RULES_FOR_DEALERSHIP':
      return { ...state, dealershipRules: payload };
    default: {
      return state;
    }
  }
};

export const getTagsForDealership = (state = initialState.dealershipTags, { type, payload }) => {
  switch (type) {
    case 'GET_TAGS_FOR_DEALERSHIP':
      return { ...state, dealershipTags: payload };
    default: {
      return state;
    }
  }
};

export const getDoses = (state = initialState.doses, { type, payload }) => {
  switch (type) {
    case 'DOSESADD':
      return { ...state, doses: payload };
    case 'DOSESAPP':
      return { ...state, doses: [...state.doses, payload] };
    case 'DOSESUP':
      return {
        ...state,
        doses: state.doses.map((dose) => (dose.id === payload.id ? payload : dose)),
      };
    case 'DOSESFIL':
      return {
        ...state,
        doses: [...state.doses.filter((a) => a.publishDate === payload)],
      };
    default: {
      return state;
    }
  }
};
export const getDoseDetails = (state = initialState.doseDetails, { type, payload }) => {
  switch (type) {
    case 'DOSEDETAILS':
      return { ...state, doseDetails: payload };
    default: {
      return state;
    }
  }
};

export const getCapstoneActivityDetails = (state = initialState.capstoneactivitydetails, { type, payload }) => {
  switch (type) {
    case 'CAPSTONEACTIVITYDETAILS':
      return { ...state, capstoneactivitydetails: payload };
    default: {
      return state;
    }
  }
};
export const getAssignedJourneys = (state = initialState.assignedJourneys, { type, payload }) => {
  switch (type) {
    case 'ASSIGNEDJOURNEYS':
      return { ...state, assignedJourneys: payload };
    default: {
      return state;
    }
  }
};
export const getPlanAssignedJourneys = (state = initialState.planassignedJourneys, { type, payload }) => {
  switch (type) {
    case 'PLANASSIGNEDJOURNEYS':
      return { ...state, planassignedJourneys: payload };
    case 'UNASSIGNJPLAN':
      return {
        ...state,
        planassignedJourneys: [
          ...state.planassignedJourneys.filter((journey) => payload.indexOf(journey.id.toString()) === -1),
        ],
      };
    case 'ASSIGNJPLAN':
      return {
        ...state,
        planassignedJourneys: [...state.planassignedJourneys, payload],
      };
    default: {
      return state;
    }
  }
};

export const getCapstoneActivityList = (state = initialState.capstoneactivitylist, { type, payload }) => {
  switch (type) {
    case 'CAPSTONEACTIVITYLIST':
      return { ...state, capstoneactivitylist: payload };
    case 'DELCAPSTONEACTIVITYLIST':
      return {
        ...state,
        capstoneactivitylist: [...state.capstoneactivitylist.filter((a) => a.id !== payload)],
      };
    default: {
      return state;
    }
  }
};
export const getCapstoneDetails = (state = initialState.capstonedetails, { type, payload }) => {
  switch (type) {
    case 'CAPSTONEDETAILS':
      return { ...state, capstonedetails: payload };
    case 'DELETECAPSTONE':
      return [];
    default: {
      return state;
    }
  }
};
export const getGuideDetails = (state = initialState.guidedetails, { type, payload }) => {
  switch (type) {
    case 'GUIDEDETAILS':
      return { ...state, guidedetails: payload };
    default: {
      return state;
    }
  }
};
export const getAuthClientDetails = (state = initialState.authclientdetails, { type, payload }) => {
  switch (type) {
    case 'AUTHCLIENTDETAILS':
      return { ...state, authclientdetails: payload };
    default: {
      return state;
    }
  }
};

export const getLevelDetails = (state = initialState.leveldetails, { type, payload }) => {
  switch (type) {
    case 'levelDetails':
      if (payload?.length === 0) {
        return { leveldetails: [] };
      }
      return { ...state, leveldetails: payload };

    case 'editLevelDetails':
      return {
        ...state,
        leveldetails: {
          ...state.leveldetails,
          description: payload.description,
          title: payload.title,
        },
      };
    case 'GUIDEDETAILSLEVELS':
      return {
        leveldetails: {
          ...state.leveldetails,
          guides: state.leveldetails.guides.map((guide) =>
            guide.id === payload.id
              ? {
                  ...guide,
                  id: payload.id,
                  title: payload.title,
                  duration: payload.duration,
                  thumbnail: payload.thumbnail,
                }
              : guide,
          ),
        },
      };
    case 'UPDATECAPSTONEACTCOUNTLEVEL':
      return {
        ...state,
        leveldetails: {
          ...state.leveldetails,
          capstoneActivitiesCount: state.leveldetails.capstoneActivitiesCount + 1,
        },
      };
    case 'DECCAPSTONEACTCOUNTLEVEL':
      return {
        ...state,
        leveldetails: {
          ...state.leveldetails,
          capstoneActivitiesCount: state.leveldetails.capstoneActivitiesCount - 1,
        },
      };
    case 'DELETECAPSTONEACTCOUNTLEVEL':
      return {
        ...state,
        leveldetails: {
          ...state.leveldetails,
          capstoneActivitiesCount: 0,
        },
      };
    case 'GUIDEDETAILSLEVELSUPDATE':
      return {
        leveldetails: {
          ...state.leveldetails,
          guides: [
            ...state.leveldetails.guides,
            {
              id: payload.id,
              title: payload.title,
              duration: payload.duration,
              thumbnail: payload.thumbnail,
            },
          ],
        },
      };
    case 'ADDGUIDES':
      return {
        leveldetails: { ...state.leveldetails, guides: payload },
      };
    case 'GUIDEDETAILSLEVELSDELETE':
      return {
        leveldetails: {
          ...state.leveldetails,
          guides: [...state.leveldetails.guides.filter((a) => a.id !== payload)],
        },
      };
    default: {
      return state;
    }
  }
};

export const getJourneyList = (state = initialState.journeylist, { type, payload }) => {
  switch (type) {
    case ActionTypes.GET_JOURNEYLIST:
      return { ...state, journeylist: payload };
    case 'UPDATEJLIST':
      return {
        ...state,
        journeylist: [
          {
            id: payload.id,
            title: payload.title,
            journeyTags: payload.tags?.map((val) => val.title),
            publishDate: payload.publishDate,
          },
          ...state.journeylist,
        ],
      };
    case 'EDITJLIST':
      return {
        ...state,
        journeylist: state.journeylist.map((journey) =>
          journey.id === payload.id
            ? {
                ...journey,
                title: payload.title,
                journeyTags: payload.tags?.map((val) => val.title),
                publishDate: payload.publishDate,
              }
            : journey,
        ),
      };
    default: {
      return state;
    }
  }
};
export const getPlanList = (state = initialState.planlist, { type, payload }) => {
  switch (type) {
    case ActionTypes.GET_PLANLIST:
      return { ...state, planlist: payload };
    case 'UPDATETITLE':
      return {
        ...state,
        planlist: state.planlist?.map((plan) =>
          plan.id === payload.id
            ? {
                ...plan,
                title: payload.title,
              }
            : plan,
        ),
      };
    case 'UPDATEPLIST':
      return { ...state, planlist: [...state.planlist, payload] };
    case 'UPDATEPLISTJCOUNT':
      return {
        ...state,
        planlist: [
          // eslint-disable-next-line no-unsafe-optional-chaining
          ...state.planlist?.map((val) => {
            if (val.id === payload.id) {
              return {
                id: val.id,
                title: val.title,
                journeysCount: payload.len,
              };
            }
            return val;
          }),
        ],
      };
    default: {
      return state;
    }
  }
};
export const getCollectionList = (state = initialState.collectionlist, { type, payload, id }) => {
  switch (type) {
    case ActionTypes.GET_COLLECTIONLIST:
      return { ...state, collectionlist: payload, selectedId: id };
    case 'UPDATEID':
      return { ...state, selectedId: id };
    case 'UPDATECOLLECTIONTITLE':
      return {
        ...state,
        collectionlist: state.collectionlist?.map((collection) =>
          collection.id === payload.id
            ? {
                ...collection,
                title: payload.title,
              }
            : collection,
        ),
      };
    case 'UPDATEDETAILS':
      return {
        ...state,
        collectionlist: state.collectionlist?.map((collection) =>
          collection.id === payload.id
            ? {
                ...collection,
                title: payload.title,
                categories: payload.categories,
                expertiseLevel: payload.expertiseLevel,
                certificate: payload.certificate,
              }
            : collection,
        ),
      };
    case 'UPDATECLIST':
      return { ...state, collectionlist: [...state.collectionlist, payload] };
    case 'UPDATECLISTJCOUNT':
      return {
        ...state,
        collectionlist: [
          ...state.collectionlist.map((val) => {
            if (val.id === payload.id) {
              return {
                ...val,
                journeys: payload.journeys,
              };
            }
            return val;
          }),
        ],
      };
    default: {
      return state;
    }
  }
};

export const categoryData = (state = initialState.category, { type, payload, activeTabId }) => {
  switch (type) {
    case 'SET_CATEGORY_LIST': {
      const firstCategory = payload && payload.length ? payload[0] : {};
      const activeCategory = activeTabId ? payload.find((p) => p.id === activeTabId) : firstCategory;

      return {
        ...state,
        categoryList: payload,
        selectedId: activeCategory.id,
      };
    }
    case 'SET_CATEGORY_DEPT': {
      return {
        ...state,
        selectedCategoryDept: payload,
        selectedId: activeTabId,
      };
    }
    case 'SET_SELECTED_DEPT_COL': {
      return {
        ...state,
        selectedCategoryDeptCollections: payload,
        selectedId: activeTabId,
      };
    }
    case 'REMOVE_CATEGORY_DETAILS': {
      const firstCategory = state.categoryList && state.categoryList.length ? state.categoryList[0] : {};
      const index = state.categoryList.findIndex((l) => l.id === payload) || {};
      state.categoryList.splice(index, 1);
      return {
        ...state,
        selectedId: firstCategory.id,
        selectedLeaderboardDetails: firstCategory,
      };
    }
    default: {
      return state;
    }
  }
};

export const getLeaderboard = (state = initialState.leaderboard, { type, payload }) => {
  switch (type) {
    case 'SET_LEADERBOARD_ID': {
      return {
        ...state,
        selectedLeaderboard: payload,
      };
    }
    case 'GET_LEADERBOARD_LIST': {
      return {
        ...state,
        leaderboardList: payload,
      };
    }
    case 'GET_LEADERBOARD_OVERVIEW': {
      return {
        ...state,
        leaderboardOverview: payload,
      };
    }
    default: {
      return state;
    }
  }
};
export const leaderboardData = (state = initialState.leaderboard, { type, payload, activeTabId }) => {
  switch (type) {
    case 'SET_LEADERBOARD_LIST': {
      const firstLeaderboard = payload && payload.length ? payload[0] : {};
      const activeLeaderboard = activeTabId ? payload.find((p) => p.id === activeTabId) : firstLeaderboard;

      return {
        ...initialState.leaderboard,
        leaderboardList: payload,
        selectedId: activeLeaderboard.id,
        selectedLeaderboardDetails: activeLeaderboard,
        selectedLeaderboardDealershipList: activeLeaderboard.dealerships || [],
      };
    }
    case 'GET_LEADERBOARD_DETAILS': {
      const leaderboardById = state.leaderboardList.find((l) => l.id === payload) || {};
      return {
        ...state,
        selectedLeaderboardDetails: leaderboardById,
        selectedId: payload,
        selectedLeaderboardDealershipList: leaderboardById.dealerships || [],
      };
    }
    case 'REMOVE_LEADERBOARD_DETAILS': {
      const firstLeaderboard = state.leaderboardList && state.leaderboardList.length ? state.leaderboardList[0] : {};
      const index = state.leaderboardList.findIndex((l) => l.id === payload) || {};
      state.leaderboardList.splice(index, 1);
      return {
        ...state,
        selectedId: firstLeaderboard.id,
        selectedLeaderboardDetails: firstLeaderboard,
        selectedLeaderboardDealershipList: firstLeaderboard.dealerships || [],
      };
    }
    default: {
      return state;
    }
  }
};
export const networkPartnerData = (state = initialState.networkPartner, { type, payload }) => {
  switch (type) {
    case 'SET_NETWORK_PARTNER_LIST': {
      return {
        ...state,
        networkPartnerList: payload,
      };
    }
    default: {
      return state;
    }
  }
};

export const rnpData = (state = initialState.rnp, { type, payload }) => {
  switch (type) {
    case 'SET_RNP_LIST': {
      return {
        ...state,
        rnpList: payload,
      };
    }
    case 'GET_RNP_DETAILS': {
      return {
        ...state,
        rnpDetails: payload,
        selectedType: payload?.type,
      };
    }
    case 'SET_SELECTED_TYPE': {
      return {
        ...state,
        selectedType: payload,
      };
    }
    default: {
      return state;
    }
  }
};

export const contestData = (state = initialState.contest, { type, payload, activeTabId }) => {
  switch (type) {
    case 'SET_CONTEST_LIST': {
      const firstContest = payload && payload.length ? payload[0] : {};
      const activeContest = activeTabId ? payload.find((p) => p.id === activeTabId) : firstContest;
      return {
        ...initialState.contest,
        contestList: payload,
        selectedId: activeContest.id,
        selectedContestDetails: activeContest,
        selectedContestDealershipCount: activeContest.dealershipCount || 0,
      };
    }
    case 'GET_CONTEST_DETAILS': {
      return {
        ...state,
        selectedContestDetails: payload,
        selectedId: payload.id,
        selectedContestDealershipCount: payload.dealershipCount || 0,
      };
    }
    case 'REMOVE_CONTEST_DETAILS': {
      const firstContest = state.contestList && state.contestList.length ? state.contestList[0] : {};
      const index = state.contestList.findIndex((l) => l.id === payload) || {};
      state.contestList.splice(index, 1);
      return {
        ...state,
        selectedId: firstContest.id,
        selectedContestDetails: firstContest,
        selectedContestDealershipCount: firstContest.dealershipCount || [],
      };
    }
    default: {
      return state;
    }
  }
};

export const adminUsersData = (state = initialState.adminUsers, { type, payload, activeTabId }) => {
  switch (type) {
    case 'SET_ADMIN_USERS_LIST': {
      const list = payload || [];
      const firstAdmin = list.length ? list[0] : {};
      const activeAdmin = activeTabId ? list.find((p) => p.id === activeTabId) || firstAdmin : firstAdmin;
      return {
        ...state,
        list,
        selectedId: activeAdmin.id ?? null,
        selectedAdminDetails: activeAdmin,
      };
    }
    case 'SET_ADMIN_USER_DETAILS': {
      return {
        ...state,
        selectedAdminDetails: payload,
        selectedId: payload?.id ?? null,
      };
    }
    default: {
      return state;
    }
  }
};

export const inappData = (state = initialState.inapp, { type, payload, activeTabId }) => {
  switch (type) {
    case 'SET_INAPP_LIST': {
      const firstInapp = payload && payload.length ? payload[0] : {};
      const activeInapp = activeTabId ? payload.find((p) => p.id === activeTabId) : firstInapp;

      return {
        ...initialState.inapp,
        inappList: payload,
        selectedId: activeInapp.id,
        selectedInappDetails: activeInapp,
        selectedInappDealershipList: activeInapp.dealerships || [],
      };
    }
    case 'GET_INAPP_DETAILS': {
      const inappById = state.inappList.find((l) => l.id === payload) || {};
      return {
        ...state,
        selectedInappDetails: inappById,
        selectedId: payload,
        selectedInappDealershipList: inappById.dealerships || [],
      };
    }
    case 'REMOVE_INAPP_DETAILS': {
      const firstInapp = state.inappList && state.inappList.length ? state.inappList[0] : {};
      const index = state.inappList.findIndex((l) => l.id === payload) || {};
      state.inappList.splice(index, 1);
      return {
        ...state,
        selectedId: firstInapp.id,
        selectedInappDetails: firstInapp,
        selectedInappDealershipList: firstInapp.dealerships || [],
      };
    }
    default: {
      return state;
    }
  }
};

export const customGroupsData = (state = initialState.customGroup, { type, payload }) => {
  switch (type) {
    case 'SET_CUSTOM_GROUP_LIST': {
      return {
        ...initialState.customGroup,
        customGroupsList: payload,
      };
    }
    case 'GET_CUSTOM_GROUP_DETAILS': {
      return {
        ...state,
        selectedId: payload,
      };
    }
    case 'SET_CUSTOM_GROUP_DETAILS': {
      return {
        ...state,
        selectedCustomGroupDetails: payload,
      };
    }
    default: {
      return state;
    }
  }
};

export const rulesData = (state = initialState.rules, { type, payload }) => {
  switch (type) {
    case 'SET_RULES_LIST': {
      return {
        ...initialState.rules,
        rulesList: payload,
      };
    }
    case 'GET_RULES_DETAILS': {
      return {
        ...state,
        selectedId: payload,
      };
    }
    case 'SET_RULES_DETAILS': {
      return {
        ...state,
        selectedRuleDetails: payload,
      };
    }
    case 'SET_RULE_JOURNEY_COUNT': {
      return {
        ...state,
        rulesList: [
          // eslint-disable-next-line no-unsafe-optional-chaining
          ...state.rulesList?.map((val) => {
            if (val.id === payload.id) {
              return {
                id: val.id,
                name: val.name,
                journeyCount: payload.journeyCount,
              };
            }
            return val;
          }),
        ],
      };
    }
    case 'DELETE_RULE': {
      const firstRule = state.rulesList && state.rulesList.length ? state.rulesList[0] : {};
      const secondRule = state.rulesList && state.rulesList.length - 1 ? state.rulesList[1] : {};
      const index = state.rulesList.findIndex((l) => l.id === payload) || {};
      state.rulesList.splice(index, 1);

      return {
        ...state,
        selectedId: firstRule.id === payload ? secondRule.id : firstRule.id,
        selectedRuleDetails: {},
      };
    }
    default: {
      return state;
    }
  }
};

export const getTopicOfTheMonth = (state = initialState.topicOfTheMonth, { type, payload }) => {
  switch (type) {
    case 'SET_DATES_LIST': {
      return {
        ...initialState.topicOfTheMonth,
        datesList: payload,
      };
    }
    case 'SET_DATE': {
      return {
        ...state,
        selectedDate: payload,
        selectedDateData: [],
        selectedTopicId: 0,
        selectedTopicData: {},
      };
    }
    case 'SET_DATE_DATA': {
      return {
        ...state,
        selectedDateData: payload,
        selectedTopicId: 0,
        selectedTopicData: {},
      };
    }
    case 'SET_TOPIC_ID': {
      return {
        ...state,
        selectedTopicId: payload,
        selectedTopicData: {},
      };
    }
    case 'SET_TOPIC_DATA': {
      return {
        ...state,
        selectedTopicData: payload,
      };
    }
    default: {
      return state;
    }
  }
};

export const getCustomDepartment = (state = initialState.customDepartment, { type, payload }) => {
  switch (type) {
    case 'SET_CUSTOM_DEPARTMENT':
      return { ...state, customDepartment: payload };
    default: {
      return state;
    }
  }
};

export const pxDashboardData = (state = initialState.pxDashboard, { type, payload }) => {
  switch (type) {
    case 'SET_PX_USERS': {
      return {
        ...initialState.pxDashboard,
        userList: payload,
      };
    }
    case 'SET_PX_USER': {
      return {
        ...state,
        selectedUser: payload,
        selectedUserTabDetails: {},
      };
    }
    case 'SET_PX_USER_DATA': {
      return {
        ...state,
        selectedUserTabDetails: payload,
      };
    }
    case 'SET_PX_FILTERS': {
      return {
        ...state,
        filters: payload,
      };
    }
    case 'CLEAR_PX_FILTERS': {
      return {
        ...initialState.pxDashboard,
      };
    }
    default: {
      return state;
    }
  }
};

export const rockedCurriculumData = (state = initialState.rockedCurriculum, { type, payload }) => {
  switch (type) {
    case 'SET_ROLES': {
      return {
        ...state,
        rolesList: payload,
      };
    }

    case 'SET_ROLE': {
      return {
        ...state,
        selectedRole: payload,
        selectedRoleTabDetails: {},
      };
    }

    case 'SET_TENURE': {
      return {
        ...state,
        selectedTenure: payload,
      };
    }

    case 'SET_TENURES': {
      return {
        ...state,
        tenures: payload,
      };
    }

    default: {
      return state;
    }
  }
};

// RockED Fuel
export const rockedFuelData = (state = initialState.rockedFuel, { type, payload }) => {
  switch (type) {
    case 'SET_CATEGORIES': {
      return {
        ...state,
        categoriesList: payload,
      };
    }

    case 'SET_CATEGORY': {
      return {
        ...state,
        selectedCategory: payload,
      };
    }

    case 'SET_SUBCATEGORY': {
      return {
        ...state,
        selectedSubCategory: payload,
      };
    }

    case 'SET_FUEL': {
      return {
        ...state,
        selectedFuel: payload,
      };
    }

    case 'SET_FUELS': {
      return {
        ...state,
        fuels: payload,
      };
    }

    default: {
      return state;
    }
  }
};

// Topics
export const topicsData = (state = initialState.topics, { type, payload }) => {
  switch (type) {
    case 'SET_TOPICS': {
      return {
        ...state,
        topicsList: payload,
      };
    }

    case 'SET_TOPIC': {
      return {
        ...state,
        selectedTopic: payload,
      };
    }

    case 'SET_TOPIC_INFO': {
      return {
        ...state,
        selectedTopicInfo: payload,
      };
    }

    default: {
      return state;
    }
  }
};

// certificate
export const certificateData = (state = initialState.certificates, { type, payload }) => {
  switch (type) {
    case 'SET_CERTS': {
      return {
        ...state,
        certList: payload,
      };
    }

    case 'SET_CERT': {
      return {
        ...state,
        selectedCert: payload,
      };
    }

    case 'SET_CERT_INFO': {
      return {
        ...state,
        selectedCertInfo: payload,
      };
    }
    case 'SET_CERT_INFO_EDIT': {
      return {
        ...state,
        selectedCertInfoEdit: payload,
      };
    }
    case 'SET_CERT_INFO_STAT': {
      return {
        ...state,
        selectedCertInfo: {
          ...state.selectedCertInfo,
          averageCount: payload.averageCount,
          usersCount: payload.usersCount,
        },
      };
    }

    default: {
      return state;
    }
  }
};

// ai roleplay
export const aiRoleplayData = (state = initialState.aiRoleplay, { type, payload }) => {
  switch (type) {
    case 'SET_EXERCISES_CATS': {
      return {
        ...state,
        exerciseCategories: payload,
      };
    }

    case 'SET_EXERCISE_CAT': {
      return {
        ...state,
        selectedCategory: payload,
      };
    }

    case 'SET_EXERCISE': {
      return {
        ...state,
        exercise: payload,
      };
    }

    case 'SELECTED_EXERCISE': {
      return {
        ...state,
        selectedExercise: payload,
      };
    }

    default: {
      return state;
    }
  }
};

export const getPlanDetails = (state = initialState.plandetails, { type, payload }) => {
  switch (type) {
    case 'PLANDETAILS':
      return { ...state, plandetails: payload };
    case 'DELETEPLAN':
      return [];
    default: {
      return state;
    }
  }
};
export const getCategoryList = (state = initialState.catlist, { type, payload }) => {
  switch (type) {
    case 'CATLIST':
      return { ...state, catlist: payload };
    default: {
      return state;
    }
  }
};
export const getEmployeeList = (state = initialState.employeelist, { type, payload }) => {
  switch (type) {
    case ActionTypes.GET_EMPLOYEELIST:
      return { ...state, employeelist: payload };
    default: {
      return state;
    }
  }
};
export const getBadgeTypeList = (state = initialState.badgeTypeList, { type, payload }) => {
  switch (type) {
    case 'ADDBADGETYPELIST':
      return { ...state, badgeTypeList: payload };
    case 'INCBADGECOUNT':
      return {
        ...state,
        badgeTypeList: state.badgeTypeList.map((item) => {
          if (item.type === payload) {
            return {
              ...item,
              count: item.count + 1,
            };
          }
          return item;
        }),
      };
    case 'DECBADGECOUNT':
      return {
        ...state,
        badgeTypeList: state.badgeTypeList.map((item) => {
          if (item.type === payload) {
            return {
              ...item,
              count: item.count - 1,
            };
          }
          return item;
        }),
      };
    default: {
      return state;
    }
  }
};
export const getAuthClientList = (state = initialState.authClientList, { type, payload }) => {
  switch (type) {
    case 'ADDAUTHCLIENTLIST':
      return { ...state, authClientList: payload };
    case 'UPDATEAUTHCLIENTLIST':
      return {
        ...state,
        authClientList: state.authClientList.map((item) => {
          if (item.id === payload.id) {
            return {
              ...item,
              name: payload.name,
            };
          }
          return item;
        }),
      };
    case 'APPENDAUTHCLIENTLIST':
      return {
        ...state,
        authClientList: [...state.authClientList, payload],
      };
    default: {
      return state;
    }
  }
};
export const getPlanAuth = (state = initialState.planAuth, { type, payload }) => {
  switch (type) {
    case 'ADDPLANAUTH':
      return { ...state, planAuth: payload };
    default: {
      return state;
    }
  }
};
export const getAddCollectionFilters = (state = initialState.collectionfilters, { type, payload }) => {
  switch (type) {
    case 'ADDCOLLECTIONFILTERS':
      return { ...state, collectionfilters: payload };
    default: {
      return state;
    }
  }
};
export const getCollection = (state = initialState.collection, { type, payload }) => {
  switch (type) {
    case 'ADDCOLLECTION':
      return { ...state, collection: payload };
    case 'UPDATECOLLECTION':
      return {
        ...state,
        collection: {
          ...state.categories,
          id: payload.id,
          title: payload.title,
          goal: payload.goal,
          description: payload.description,
          enabled: payload.enabled,
          journeys: payload.journeys,
          expertiseLevel: payload.expertiseLevel,
          categories: payload.categories,
          certificate: payload.certificate,
          initalCheckinId: payload.initalCheckinId,
          finalCheckinId: payload.finalCheckinId,
          preAssessmentId: payload.preAssessmentId,
          postAssessmentId: payload.postAssessmentId,
          contentType: payload.contentType,
          rnpName: payload.rnpName,
          rockedNetworkPartnerId: payload.rockedNetworkPartnerId,
          dueDate: payload.dueDate,
        },
      };
    case 'UPDATECJOURNEY':
      return {
        ...state,
        collection: { ...state.collection, journeys: payload },
      };
    case 'ADD_CHECKIN_IDS':
      return {
        ...state,
        collection: {
          ...state.collection,
          initalCheckinId: payload.initalCheckinId,
          finalCheckinId: payload.finalCheckinId,
        },
      };
    default: {
      return state;
    }
  }
};
export const getDealershipMenu = (state = initialState.dealershipMenu, { type, payload }) => {
  switch (type) {
    case 'DEALERSHIPMENU':
      return { ...state, dealershipMenu: payload };
    case 'INCEMPCOUNT':
      return {
        ...state,
        dealershipMenu: [
          ...state.dealershipMenu.map((val) => {
            if (val.id === payload.id) {
              return {
                id: val.id,
                title: val.title,
                employeeCount: (val.employeeCount || 0) + 1,
              };
            }
            return val;
          }),
        ],
      };
    case 'DECEMPCOUNT':
      return {
        ...state,
        dealershipMenu: [
          ...state.dealershipMenu.map((val) => {
            if (val.id === payload.id) {
              return {
                id: val.id,
                title: val.title,
                employeeCount: (val.employeeCount || 0) - 1,
              };
            }
            return val;
          }),
        ],
      };
    default: {
      return state;
    }
  }
};

export const getDealershipDepartments = (state = initialState.dealershipDepartmentValues, { type, payload }) => {
  switch (type) {
    case 'SET_DEALERSHIP_DEPARTMENT_VALUES':
      return { ...state, dealershipDepartmentValues: payload };

    default: {
      return state;
    }
  }
};

export const getAllBadges = (state = initialState.allbadges, { type, payload }) => {
  switch (type) {
    case 'ADDBADGE':
      return { ...state, allbadges: payload };
    case 'UPDATEBADGE':
      return {
        ...state,
        allbadges: state.allbadges.map((item) => {
          if (item.id === payload.id) {
            return {
              ...item,
              name: payload.name,
              unlockedImageUrl: payload.unlockedImageUrl,
            };
          }
          return item;
        }),
      };
    case 'APPENDBADGE':
      return {
        ...state,
        allbadges: [...state.allbadges, payload],
      };
    case 'REMOVEBADGE':
      return {
        ...state,
        allbadges: [...state.allbadges.filter((a) => a.id !== payload.id)],
      };
    default: {
      return state;
    }
  }
};
export const getJourneyDetails = (state = initialState.journeydetails, { type, payload }) => {
  switch (type) {
    case ActionTypes.JOURNEYDETAILS:
      return { ...state, journeydetails: payload };
    case 'DELETELEVELIDS':
      return {
        ...state,
        journeydetails: {
          ...state.journeydetails,
          levels: state.journeydetails.levels.filter((a) => a.id !== payload),
        },
      };
    case 'UPDATELEVELIDS':
      return {
        ...state,
        journeydetails: {
          ...state.journeydetails,
          levels: [...state.journeydetails.levels, payload],
        },
      };
    case 'UPDATELEVEL':
      return {
        journeydetails: {
          ...state.journeydetails,
          levels: state.journeydetails.levels.map((level) =>
            level.id === payload.id
              ? {
                  id: payload.id,
                  title: payload.title,
                }
              : level,
          ),
        },
      };
    case 'APPENDLEVELIDS':
      return {
        ...state,
        journeydetails: { ...state.journeydetails, levels: payload },
      };
    case 'UPDATEJOURNEY':
      return {
        ...state,
        journeydetails: {
          ...state.journeydetails,
          title: payload.title,
          description: payload.description,
          goal: payload.goal,
          thumbnail: payload.thumbnail,
          certificate: payload.certificate,
          skillLevel: payload.skillLevel,
          journeyTags: payload.tags,
          publishDate: payload.publishDate,
          previewVideoLink: payload.previewVideoLink,
          journeyCategories: payload.categories,
          journeyCollections: payload.collections,
          isOEM: payload.isOEM,
          dueDate: payload.dueDate,
        },
      };
    case 'ADD_CHECKIN_ID':
      return {
        ...state,
        journeydetails: {
          ...state.journeydetails,
          checkinId: payload.checkinId,
        },
      };
    default: {
      return state;
    }
  }
};

export const getDepartment = (state = deptID, { type, payload }) => {
  switch (type) {
    case 'DEPT':
      deptID = payload;
      return deptID;

    default:
      return state;
  }
};

export const getDepartmentRole = (state = initialState.departmentRole, { type, payload }) => {
  switch (type) {
    case 'CLEAR':
      return [];
    case 'DEPT_ROLES':
      return [...state, payload];
    default:
      return state;
  }
};
export const getAllDepartments = (state = initialState.departments, { type, payload }) => {
  switch (type) {
    case 'ALL_DEPT':
      return { ...state, departments: payload };

    default:
      return state;
  }
};
export const getSelectedDeptRoles = (state = initialState.selDeptRoles, { type, payload }) => {
  const dupe = state.selDeptRoles.find((obj) => obj?.id === payload?.id);
  switch (type) {
    case 'ADD_SEL':
      return { ...state, selDeptRoles: payload };
    case 'CLEAR_SEL':
      return { ...state, selDeptRoles: [] };
    case 'APP_SEL_DEPT_ROLES':
      return dupe ? state : { ...state, selDeptRoles: [...state.selDeptRoles, payload] };
    case 'REM_SEL_DEPT_ROLES':
      return {
        ...state,
        selDeptRoles: [...state.selDeptRoles.filter((a) => a?.id !== payload?.id)],
      };
    default:
      return state;
  }
};
export const setDepartmentEmpCnt = (state = deptEmpCnt, { type, payload }) => {
  switch (type) {
    case 'EMP':
      deptEmpCnt = payload;
      return deptEmpCnt;
    default:
      return state;
  }
};

export const showProgress = (state = progress, { type, payload }) => {
  switch (type) {
    case 'PROGRESS':
      progress = payload;
      return progress;

    default:
      return state;
  }
};

export const setDevAccess = (state = initialState.devAccess, { type, payload }) => {
  switch (type) {
    case 'DEV_ACCESS':
      return { ...state, devAccess: payload };

    default:
      return state;
  }
};

export const showDevPanel = (state = initialState.isDevPanelOpen, { type }) => {
  switch (type) {
    case 'DEV_PANEL':
      return { ...state, isDevPanelOpen: !state.isDevPanelOpen };

    default:
      return state;
  }
};

export const getDEVTabId = (state = devTabID, { type, payload }) => {
  switch (type) {
    case 'DEV_PANEL_TAB_ID':
      devTabID = payload;
      return devTabID;
    default:
      return state;
  }
};

export const getQuizSeriesList = (state = initialState.quizSeriesList, { type, payload }) => {
  switch (type) {
    case 'QUIZ_SERIES_LIST':
      return { ...state, quizSeriesList: payload };
    default:
      return state;
  }
};

export const getQuizSeries = (state = initialState.quizSeries, { type, payload, id }) => {
  switch (type) {
    case 'QUIZ_SERIES_OVERVIEW':
      return { ...state, quizSeriesOverview: payload, selectedId: id };
    default:
      return state;
  }
};

export const getQuiz = (state = initialState.quiz, { type, payload, id }) => {
  switch (type) {
    case 'QUIZ_DETAILS':
      return { ...state, quizDetails: payload, selectedId: id };
    default:
      return state;
  }
};
